export default {"src":"/_next/static/image/public/images/flags/flag_680.6efa7c0d46c48b215971ffcef7c19eaf.svg","height":16,"width":24};